import { render, staticRenderFns } from "./CulturaModal.vue?vue&type=template&id=a12bcd0a&scoped=true"
import script from "./CulturaModal.vue?vue&type=script&lang=js"
export * from "./CulturaModal.vue?vue&type=script&lang=js"
import style0 from "./CulturaModal.vue?vue&type=style&index=0&id=a12bcd0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12bcd0a",
  null
  
)

export default component.exports